import { IMangaInfo } from "./MangaInfo";
import { CSSProperties } from "react";

/**
 * 縦表示かどうか
 */
export const createImageStyle = (
	info: IMangaInfo
) => {
	const margin = 50;
	const style: CSSProperties = {
		margin: margin + "px",
		objectFit: "contain"
	};

	const scaleX = info.width / window.innerWidth;
	const scaleY = info.height / window.innerHeight;

	// 画像が縦長か横長かで変える
	if ( scaleX < scaleY ) {
		style.height = Math.floor( ((info.height - margin * 2) / info.height) * 100 ) + "%";
	} else {
		style.width = Math.floor( ((info.width - margin * 2) / info.width) * 100 ) + "%";
	}

	return style;
};

export const createSeparateImageSet = (
	info: IMangaInfo,
	maxHeightPer: number = 100
) => {
	const margin = 20;
	const style: CSSProperties = {};

	// portraitのみ想定
	// 画像をwindowの何パーセントで表示するか計算して設定する
	const scaleY = (info.height - margin * 2) / info.height;
	const scaleY100temp = Math.floor( scaleY * 100 );
	const scaleY100 = scaleY100temp > maxHeightPer ? maxHeightPer : scaleY100temp;
	style.height = scaleY100 + "%";

	// 実際にwindowに表示される画像の高さを計算する
	const viewImgHeight = window.innerHeight * (scaleY100 * 0.01);
	style.marginTop = `${Math.floor( (window.innerHeight - viewImgHeight) * 0.5 )}px`;

	// 実際にwindowに表示される画像の高さの比から、表示される画像の幅を求める
	const viewScale = viewImgHeight / info.height;
	const viewWidth = (info.width * viewScale);

	// 画像幅のうち、はみ出している領域のサイズを計算
	const overWidth = window.innerWidth - viewWidth - margin;

	return {
		style: style,
		from: `${Math.floor( (overWidth) / window.innerWidth * 100 )}%`,
		to: `${100 - Math.floor( (window.innerWidth) / (window.innerWidth + margin) * 100 )}%`
	};
};
//
// export const createSeparateImageSet = (
// 	info: IMangaInfo,
// 	maxHeightPer: number = 100
// ) => {
// 	const margin = 20;
// 	const style: CSSProperties = {};
// 	const parentStyle: CSSProperties = {};
//
// 	// todo 今はテスト版なので、portraitの想定
// 	// 画像をwindowの何パーセントで表示するか計算して設定する
// 	const scaleY = (info.height - margin * 2) / info.height;
// 	const scaleY100temp = Math.floor( scaleY * 100 );
// 	const scaleY100 = scaleY100temp > maxHeightPer ? maxHeightPer : scaleY100temp;
// 	parentStyle.height = scaleY100 + "vh";
// 	style.height = "96%"; // 2%ずつマージン
// 	style.margin = "2%";
//
// 	// 実際にwindowに表示される画像の高さを計算する
// 	const viewImgHeight = window.innerHeight * (scaleY100 * 0.01);
// 	// style.marginTop = `${Math.floor( (window.innerHeight - viewImgHeight) * 0.5 )}px`;
//
// 	// 実際にwindowに表示される画像の高さの比から、表示される画像の幅を求める
// 	const viewScale = viewImgHeight / info.height;
// 	const viewWidth = (info.width * viewScale);
//
// 	// 画像幅のうち、はみ出している領域のサイズを計算
// 	const overWidth = window.innerWidth - viewWidth - margin * 2;
//
// 	return {
// 		style: style,
// 		parentStyle: parentStyle,
// 		from: `${Math.floor( (overWidth) / window.innerWidth * 100 )}%`,
// 		to: `${100 - Math.floor( (window.innerWidth) / (window.innerWidth + margin * 2) * 100 )}%`
// 	};
// };
